import * as React from 'react'

import {
  Box,
  type Colors,
  Icon,
  type MediumIcon,
  Text,
  Tooltip,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  access: string
  permission: string
  showLabel?: boolean
}

interface PermissionProps {
  icon: MediumIcon
  color: Colors
  title: string
  label: string
}

const accessLevel = (access: string, permission: string): PermissionProps => {
  switch (access) {
    case 'public':
    default:
      return {
        icon: 'check-circle',
        color: 'lime1000',
        title: i18n.t(
          'documents.document_templates.all_available_variables_list.access.public.title'
        ),
        label: i18n.t(
          'documents.document_templates.all_available_variables_list.access.public.label'
        ),
      }
    case 'full':
      return {
        icon: 'check-circle',
        color: 'lime1000',
        title: i18n.t(
          'documents.document_templates.all_available_variables_list.access.full.title'
        ),
        label: i18n.t(
          'documents.document_templates.all_available_variables_list.access.full.label',
          { permission: permission }
        ),
      }
    case 'partial':
      return {
        icon: 'alert-circle',
        color: 'champagne1000',
        title: i18n.t(
          'documents.document_templates.all_available_variables_list.access.partial.title'
        ),
        label: i18n.t(
          'documents.document_templates.all_available_variables_list.access.partial.label',
          { permission: permission }
        ),
      }
    case 'no_access':
      return {
        icon: 'cross-circle',
        color: 'radicalRed1500',
        title: i18n.t(
          'documents.document_templates.all_available_variables_list.access.no_access.title'
        ),
        label: i18n.t(
          'documents.document_templates.all_available_variables_list.access.no_access.label',
          { permission: permission }
        ),
      }
  }
}

const AccessInfo = ({ access, permission, showLabel = false }: Props) => {
  const accessInfo = accessLevel(access, permission)
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt
      attachment="bottom center"
      targetAttachment="top center"
      toggle={toggle}
      open={open}
      label={accessInfo.label}
    >
      <Box flexDirection="row" alignItems="center" gap="s4">
        <Icon.Medium icon={accessInfo.icon} color={accessInfo.color} />
        {showLabel && (
          <Text.Normal weight="medium" size="200">
            {accessInfo.title}
          </Text.Normal>
        )}
      </Box>
    </Tooltip.Alt>
  )
}

export default AccessInfo
